module.exports = __webpack_public_path__ + "static/media/page-break.79524178.svg";